import * as React from 'react';
import { I18n } from '@ies/starling_intl';
import { I18nContext, getI18n } from './context';
export var EVENT_NAME;
(function (EVENT_NAME) {
    EVENT_NAME["languageChanged"] = "languageChanged";
    EVENT_NAME["loaded"] = "loaded";
    EVENT_NAME["initialized"] = "initialized";
})(EVENT_NAME || (EVENT_NAME = {}));
export var STORE_EVENT_NAME;
(function (STORE_EVENT_NAME) {
    STORE_EVENT_NAME["added"] = "added";
})(STORE_EVENT_NAME || (STORE_EVENT_NAME = {}));
export function IntlProvider(props) {
    var _a = React.useState(false), _flag = _a[0], setRefreshFlag = _a[1];
    var onInstanceChange = React.useCallback(function (type) {
        setRefreshFlag(function (prev) { return !prev; });
    }, []);
    var i18n = props.i18n || getI18n() || I18n;
    var nowLocale = props.locale || (i18n || {}).i18nInstance.instance.language || undefined;
    React.useEffect(function () {
        // i18n instance 几乎不会怎么变
        if (!i18n) {
            return;
        }
        var coreInstance = i18n.i18nInstance.instance;
        // add event listener
        Object.keys(EVENT_NAME).forEach(function (event) {
            coreInstance.on(event, function () { return onInstanceChange(event); });
        });
        Object.keys(STORE_EVENT_NAME).forEach(function (event) {
            coreInstance.store.on(event, function () { return onInstanceChange(event); });
        });
        return function () {
            Object.keys(EVENT_NAME).forEach(function (event) {
                coreInstance.off(event);
            });
            Object.keys(STORE_EVENT_NAME).forEach(function (event) {
                coreInstance.store.off(event);
            });
        };
    }, [i18n]);
    var value = React.useMemo(function () { return ({
        i18n: i18n,
        locale: nowLocale || I18n.i18nInstance.instance.language
    }); }, [i18n, nowLocale, _flag]);
    return React.createElement(I18nContext.Provider, { value: value }, props.children);
}
export default IntlProvider;
//# sourceMappingURL=Provider.js.map